/*
 * @Author: yzr
 * @Date: 2020-12-02 18:18:21
 * @LastEditors: yzr
 * @LastEditTime: 2020-12-02 18:22:04
 */
import RuleList from './rule_list.vue';

export default RuleList;
